import { useState } from 'react';

import { CompetitionType } from '../InviteFriendsPage';

import useToast from '@/hooks/useToast';
import useTourney from '@/hooks/useTourney';
import {
  ActionTypeManageFCupEnum,
  requestPostulantManagementFCup,
} from '@/services/friendsCup';
import { manageMLRequest } from '@/services/minileagues';
import { ActionTypeManageTDAEnum, postManagePostulant } from '@/services/tda';
import { InitialDataTourneys } from '@/store';
import { DatosParticipanteMiniLigasTO } from '@/types/minileagues';
import { TEXTS } from '@/utils';

interface HandlePostulacion {
  type: string;
  idTorneo: number;
  onInvite: (userId: number) => Promise<boolean | undefined>;
  tourneyData: InitialDataTourneys;
}

export const useHandlePostulantInvitations = (params: HandlePostulacion) => {
  const [invitedUsers, setInvitedUsers] = useState<Set<number>>(new Set());
  const [member, setMember] = useState(false);
  const toast = useToast();
  const { tourneyData } = useTourney();
  const [memberUsers, setMemberUsers] = useState<Set<number>>(new Set());

  const handleInvite = (idUser: number, userStatus?: string) => {
    if (!invitedUsers.has(idUser)) {
      if (userStatus === undefined) {
        const isPartPendingResponse = isPartPending(idUser);
        if (isPartPendingResponse) {
          managePostulantExecutor(params.idTorneo, idUser);
          setMemberUsers((prev) => new Set(prev).add(idUser));
        } else {
          params.onInvite &&
            params.onInvite(idUser).then((resp) => {
              if (resp) {
                setInvitedUsers((prev) => new Set(prev).add(idUser));
              }
            });
        }
      } else {
        if (userStatus === 'Pendiente Aceptar Dueño') {
          managePostulantExecutor(params.idTorneo, idUser);
          setInvitedUsers((prev) => new Set(prev).add(idUser));
          setMemberUsers((prev) => new Set(prev).add(idUser));
        } else {
          params.onInvite &&
            params.onInvite(idUser).then((resp) => {
              if (resp) {
                setInvitedUsers((prev) => new Set(prev).add(idUser));
              }
            });
        }
      }
    }
  };

  const managePostulantExecutor = (idTourney: number, idUser: number) => {
    const objFunc: any = {
      tournament: () => managementTournament(idTourney, idUser),
      cup: () => managementFCup(idTourney, idUser),
      minileagues: () => managementMinileagues(idTourney, idUser),
    };
    objFunc[params.type]();
  };

  const managementTournament = (idTourney: number, idUser: number) => {
    const actionType: ActionTypeManageTDAEnum = ActionTypeManageTDAEnum.Accept;
    postManagePostulant({
      actionType,
      idTourney,
      idUser,
    })
      .then(() => {
        setMember(true);
      })
      .catch(() => {
        toast.show(TEXTS.defaultError);
      });
  };

  const managementFCup = (idTourney: number, idUser: number) => {
    const actionType: ActionTypeManageFCupEnum =
      ActionTypeManageFCupEnum.ACC_ACEPTAR_POSTULACION;
    const user = params.tourneyData.tourney?.queAunNoAceptaste.find(
      (data: any) => data.idUsuario === idUser
    );
    requestPostulantManagementFCup({
      tipoAccion: actionType,
      idGrupo: idTourney,
      idParticipante: user.id,
      idUsuario: user.id,
    })
      .then(() => {
        setMember(true);
      })
      .catch(() => {
        toast.show(TEXTS.defaultError);
      });
  };

  const managementMinileagues = (idTourney: number, idUser: number) => {
    manageMLRequest(idTourney, idUser, 1)
      .then(() => {
        setMember(true);
      })
      .catch(() => {
        toast.show(TEXTS.defaultError);
      });
  };

  const isPartPending = (idUser: number) => {
    let isPartPending;
    if (params.type === CompetitionType.MINILEAGUES) {
      isPartPending = tourneyData.minileaguePartPending?.some(
        (player: DatosParticipanteMiniLigasTO) => {
          return player.part?.idUsuario === idUser;
        }
      );
    } else {
      isPartPending = tourneyData.tourneyPendings?.some((player: any) => {
        return player.idUsuario === idUser;
      });
    }
    return isPartPending;
  };

  return {
    handleInvite,
    invitedUsers,
    member,
    setMember,
    memberUsers,
    managePostulantExecutor,
  };
};
